import styled, { css } from "styled-components";
import ImageUpload from "../ImageUpload";

export const ImageUploadRoot = styled(ImageUpload)(
    () => css`
        .single-image-upload {
            flex-wrap: nowrap;
        }
        .FormControl {
            width: 100%;
        }
    `,
);
